import React, { Fragment, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import {
  deleteProduct,
  fetchProductList,
  updateItem,
} from "../actions/product";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";
import {
  createDateColumn,
  createFullDateColumn,
} from "../utils/agGridDateColumn";

const ProductList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { productList } = useSelector((state) => state.productReducer);

  //breadcrumb
  const translateModule = "product";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchProductList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.code) return null;
    return (
      <ButtonColumn
        editLink={`/product-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.code}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(deleteProduct(pageId));
  };

  const columnDefs = [
    {
      headerName: "Šifra",
      field: "code",
      filter: "agTextColumnFilter",
      width: 140,
    },
    {
      headerName: "Naziv proizvoda",
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 280,
    },
    {
      headerName: "Tip proizvoda",
      field: "type",
      filter: "agSetColumnFilter",
    },
    {
      headerName: "Pozicija",
      field: "position",
      filter: "agSetColumnFilter",
      width: 120,
    },
    {
      headerName: "Status",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      maxWidth: 150,
      // cellClass: "editable-cell",
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    createFullDateColumn("Datum kreiranja", "createdAt"),
    createFullDateColumn("Datum poslednje izmene", "updatedAt"),
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  const gridRows = useMemo(
    () =>
      Array.isArray(productList) ? productList.map((r) => ({ ...r })) : [],
    [productList]
  );

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchProductList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        onCellUpdate={updateItem}
        rowData={gridRows}
        columnDefs={columnDefs}
        buttonLink={`/product-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="product-list"
      />
    </Fragment>
  );
};

export default ProductList;
